export const ONFIDO_CONTAINER_ID = "onfido-mount";
